import clienteAxios from "../config/axios";

export async function getAllLegajos() {
    return clienteAxios.get(`/legajo`);
}

export async function getLegajosFromSoftland() {
    return clienteAxios.get(`/legajo/actualizarLegajos`);
}

export async function addLegajo(legajo) {
    return clienteAxios.post(`/legajo`,{legajo:legajo});
}

export async function updateLegajo(id,updates) {
    return clienteAxios.put(`/legajo/${id}`,{updates});
}

export async function deleteLegajo(id) {
    return clienteAxios.delete(`/legajo/${id}`,id);
}